<template>
  <div>
    <el-row :gutter="20">
      <el-col :md="24" :sm="24">
        <el-card>
          <el-button type="success" @click="exportReport()" :loading="exporting" plain>Exportar</el-button>
        </el-card>
        <app-table
          @change-pagination="onChangePagination"
          @change-search="onChangeSearch"
          :total="total">
          <el-table
            v-loading="loading"
            :data="tableData"
            style="width: 100%">
            <el-table-column
              prop="date"
              label="Fecha">
            </el-table-column>
            <el-table-column>
            <template slot-scope="scope">
              <p>{{ scope.row.observation}}
                <span v-if="scope.row.action.action !== 'Finalizacion Contrato' "></span>
                <span v-else>{{" - Motivo:  " + scope.row.contract.cont_ended_observation}}</span>
              </p>
            </template>
              label="Motivo Salida">
            </el-table-column>
            <el-table-column
              prop="company.name"
              label="Compania">
            </el-table-column>
            <el-table-column
              prop="cost_center.name"
              label="Centro de costos">
            </el-table-column>
            <el-table-column
              prop="user.name"
              label="Usuario Responsable">
            </el-table-column>
            <el-table-column
              label="Fecha Contrato">
            <template slot-scope="scope">
              <p>{{ scope.row.contract.start_date + " - "}}
                <span v-if="scope.row.contract.end_date == null">Indefinido</span>
                <span v-else>{{scope.row.contract.end_date}}</span>
              </p>
            </template>
            </el-table-column>
          </el-table>
        </app-table>
      </el-col>
    </el-row>
  </div>

</template>

<script>
  import AppTable from '../../components/Table'
  import {baseApi} from '../../configs/urls'
  import {saveAs} from 'file-saver'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import {parseError} from '../../packages/Helpers'
  export default {
    extends: BaseCrud,
    name: 'form-list',
    props: ['employee_id'],
    components: {
      AppTable
    },
    data () {
      return {
        baseUrl: baseApi + '/personal-actions',

        exporting: false
      }
    },
    watch: {
      employee_id (id) {
        this.clear()
        this.employee_id = id
        this.refreshData()
      }
    },
    methods: {
      _beforeRefresh (query) {
        query.employee_id = this.employee_id
      },
      _notifyError (message) {
        this.$notify.error({
          title: 'Error',
          message: message
        })
      },
      _beforeSend (model) {
        model.employee_id = this.employee_id
        return model
      },
      _mounted () {
        this.loadAll()
      },
      loadAll () {
        this.refreshData()
      },
      exportReport () {
        let url = baseApi + '/personal-actions/reports/excel'
        this.exporting = true
        this.$http.post(url, { employee_id: this.employee_id }, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'application/octet-stream'})
              saveAs(blob, 'Acciones de Personal.xlsx')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/employees/PersonalActions.vue